import { TableColumnProps } from 'components/table/table-component/table-component';

export const tableStructure: TableColumnProps[] = [
  {
    id: 'name',
    title: 'Name',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'path',
    title: 'Path',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'status',
    title: 'Status',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'direct',
    title: 'Direct',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'importer',
    title: 'Importers',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'import_at',
    title: 'Date',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'instances',
    title: 'Count',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'version',
    title: 'Version',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'severity',
    title: 'Vulnerability',
    position: 'center',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'action',
    title: '',
    position: 'left',
  },
];
